import styled from 'styled-components';

import { Text } from '@/nova/components';
import { COLORS, SPACE } from '@/nova/theme/tokens';

/** The line and its "See players" link, wrapping under it on a narrow panel. */
export const Wrap = styled.span`
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  column-gap: ${SPACE[8]};
  row-gap: ${SPACE[2]};
  font-size: 12px;
`;

/** The link's recent results, one muted line under the copy field. */
export const Line = styled(Text).attrs({ tag: 'span' as const })`
  display: block;
  font-size: 12px;
  color: ${COLORS.textMuted};
`;

/** "See players": the Players page filtered to this link (a real address, opened in the app on a plain click). */
export const PlayersLink = styled.a`
  font-weight: 600;
  color: ${COLORS.text};
  text-decoration: underline;
  text-decoration-color: ${COLORS.hairline};
  text-underline-offset: 3px;
  white-space: nowrap;

  &:hover,
  &:focus-visible {
    color: ${COLORS.accent};
    text-decoration-color: currentColor;
  }
`;
